export default "__VITE_ASSET__7ESKOYQg__"